import React from 'react';
import PropTypes from 'prop-types';

// components
import { Card, CardHeader } from 'material-ui/Card';
import EmailDialog from '../Message/BulkEmailDialog';
import ReportShareDialog from './ReportShareDialog';
import DetailView from '../Common/DetailView';
import ReportIcon from 'material-ui/svg-icons/action/assessment';
import { statusColours } from '../../constants/ColourConstants';
import ErrorSnackbar from '../Common/ErrorSnackbar';
import Snackbar from 'material-ui/Snackbar';

import ReportCourseProgress from './ReportCourseProgress.react';
import ReportCourseEnrolmentProgress from './ReportCourseEnrolmentProgress.react';
import ReportElearningAttemptsHistory from './ReportElearningAttemptsHistory';
import ReportEnrolmentProgress from './ReportEnrolmentProgress.react';
import ReportEventAttendance from './ReportEventAttendance';
import ReportEventAttendanceHistory from './ReportEventAttendanceHistory';
import ReportModuleEnrolmentProgress from './ReportModuleEnrolmentProgress';
import ReportModuleProgress from './ReportModuleProgress';
import ReportUserModuleProgress from './ReportUserModuleProgress';
import ReportUserProgress from './ReportUserProgress.react';
import ReportUsers from './ReportUsers.react';
// icons
import DownloadIcon from 'material-ui/svg-icons/file/file-download';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import EmailIcon from 'material-ui/svg-icons/communication/email';
import ShareIcon from 'material-ui/svg-icons/social/share';
// constants
import ROLES from '../../constants/Roles';
import { MessageDialogs, ReportDialogs } from "../../constants/Dialogs";
// business logic
import DialogActions from '../../actions/DialogActionCreator';
import ReportActions from '../../actions/ReportActionCreator';
import ReportStore from '../../stores/ReportStore';
import ReportResultStore from '../../stores/ReportResultStore';
import MessageStore from '../../stores/MessageStore';

import buildContextMenu from '../Common/BuildContextMenu';
import DialogStore from "../../stores/DialogStore";
import { withId } from "../Common/Decorators";

const style = {

    icon: {
        height: '32px',
        width: '32px',
    }
};

const Report = React.createClass({

    getInitialState: function () {
        return {
            details: {
                id: '',
                name: '',
                description: '',
                typeId: 0,
                filterId: '',
                filter: '',
                reportTypeId: '',
                reportType: '',
                reportLabel: '',
                dateFrom: new Date(),
                dateTo: new Date(),
                shareable: false,
                shareKey: null
            },
            dialogOpen: false,
            showMessage: false,
            message: '',
            results: [],
            actions: [],
            links: {
                back: '/dashboard/reports',
                edit: '',
            },

            display: {
                fixedHeader: true,
                fixedFooter: true,
                stripedRows: false,
                showRowHover: false,
                showCheckboxes: false,
                selectable: false,
                multiSelectable: false,
                enableSelectAll: false,
                deselectOnClickaway: false,
            }
        }
    },

    componentDidMount: function() {
        this.listeners = [
            ReportStore.addListener(this._onReportChange),
            ReportResultStore.addListener(this._onReportResultChange),
            MessageStore.addListener(() => this.setState({showMessage: true, message: MessageStore.getLastMessage()})),
            DialogStore.addListener(() => this.setState({dialogOpen: DialogStore.getOpenDialog() === MessageDialogs.BULK_EMAIL}))
        ];
        ReportActions.getById(this.props.routeParams.id);
        ReportActions.getResults(this.props.routeParams.id);

        this.setState({actions: buildContextMenu(this.getMenuItems(), this.context.auth)});
    },

    componentWillUnmount: function() {
        this.listeners.forEach(listener => listener.remove());
    },

    render: function() {

        let results;
        if (!!this.state.details.reportLabel) {
            const progressDetails = {
                display: this.state.display,
                data: this.state.results
            };
            switch (this.state.details.reportLabel) {
                case 'user_progress':
                    results = <ReportUserProgress {...progressDetails} />;
                    break;
                case 'course_progress':
                    results = <ReportCourseProgress {...progressDetails} />;
                    break;
                case 'course_enrolment_progress':
                    results = <ReportCourseEnrolmentProgress {...progressDetails} />;
                    break;
                case 'resource_progress':
                    results = <ReportEnrolmentProgress {...progressDetails} showScore={false}/>;
                    break;
                case 'users':
                    results = <ReportUsers {...progressDetails} />;
                    break;
                case 'user_module_progress':
                    results = <ReportUserModuleProgress {...progressDetails} />;
                    break;
                case 'module_progress':
                    results = <ReportModuleProgress {...progressDetails} />;
                    break;
                case 'module_enrolment_progress':
                    results = <ReportModuleEnrolmentProgress {...progressDetails} />;
                    break;
                case 'event_attendance_summary':
                    results = (
                        <ReportEventAttendance
                            {...progressDetails}
                            reportId={this.state.details.id}
                            month={this.props.location.query.month || null}
                        />
                    );
                    break;
                case 'event_attendance_history':
                    results = <ReportEventAttendanceHistory {...progressDetails} />;
                    break;
                case 'elearning_attempts_history':
                    results = <ReportElearningAttemptsHistory {...progressDetails} />
                    break;
                default:
                    break;
            }
        }
        return (
            <DetailView
                title="Report"
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title={`${this.state.details.name} (${this.state.details.filter})`}
                            subtitle={this.state.details.description}
                            avatar={<ReportIcon style={style.icon} color={statusColours.default}/>}
                        />
                        {results}
                    </Card>
                </div>
                {this.state.dialogOpen && (
                    <EmailDialog
                        title="Send report as email attachment"
                        onCancel={DialogActions.close}
                        onSave={this.emailResults}
                        closeOnSave
                        allowSelectRecipients
                    >
                        <span><br /><br /><em>Report will be attached to the email as a CSV file</em></span>
                    </EmailDialog>
                )}
                {!!this.state.details.shareable && (
                    <ReportShareDialog reportId={this.props.id}/>
                )}
                <Snackbar
                    open={this.state.showMessage}
                    action="OK"
                    message={this.state.message}
                    onActionTouchTap={() => this.setState({showMessage: false})}
                    onRequestClose={() => this.setState({showMessage: false})}
                />
                <ErrorSnackbar/>
            </DetailView>
        );
    },

    _onReportChange: function() {
        const details = ReportStore.getById(this.props.id);
        if (details !== undefined) {
            this.setState({details, actions: !details.shareable ? this.state.actions : buildContextMenu(this.getMenuItems(true), this.context.auth)});
        }
    },

    _onReportResultChange: function() {
        let results = ReportResultStore.getByReport(this.props.id);
        if (results !== undefined) {
            this.setState({results});
        }
    },

    _onDelete: function(entityId) {
        if (entityId === this.props.id) {
            ReportActions.delete(entityId);
            window.location.href = this.state.links.back;
        }
    },

    emailResults: function (params) {
        params.recipients = params.recipients.replace(/\s+/g, '').split(';');
        ReportActions.emailResults(this.props.routeParams.id, params);
    },

    getMenuItems: function (shareable = false) {
        return ([
            {
                action: () => DialogActions.open(ReportDialogs.REPORT_SHARE),
                label: 'Share',
                icon: <ShareIcon/>,
                condition: {
                    show: shareable
                }
            },
            {
                link: `/cent/report/${this.props.id}/results.zip`,
                label: 'Export to CSV',
                target: '_blank',
                icon: <DownloadIcon />
            },
            {
                action: () => DialogActions.open(MessageDialogs.BULK_EMAIL, {users: [], subject: '', message: ''}),
                label: 'Send as attachment',
                icon: <EmailIcon />
            },
            {
                type: 'divider'
            },
            {
                link: `/dashboard/report/${this.props.id}/edit`,
                icon: <EditIcon />,
                label: 'Edit',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: this.props.id,
                title: 'Delete ',
                deleteAction: this._onDelete,
                message: <span>Are you sure you want to delete this report?</span>,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            }
        ]);
    }

});

Report.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(Report);
